export default {
    topics: [
        {
            title: ' WorkflowTask (Class) ',
            href: 'c-WorkflowTask.html',
            attributes: { 'data-id': 'c-WorkflowTask' },
            menu: { hasChildren: false },
            tocID: 'c-WorkflowTask-d66e6774',
            next: 'c-WorkflowTask-d66e6774',
        },
        {
            title: ' WorkflowTransition (Class) ',
            href: 'c-WorkflowTransition.html',
            attributes: { 'data-id': 'c-WorkflowTransition' },
            menu: { hasChildren: false },
            tocID: 'c-WorkflowTransition-d66e6854',
            topics: [],
        },
    ],
};

